import { message } from 'ant-design-vue'
import {
  faq_deleteQa_post,
  faq_deleteTitle_post,
  faq_modifyPosition_post,
  faq_queryQa_post,
  faq_queryTitle_post,
  faq_upsertQa_post,
  faq_upsertTitle_post,
  faq_modifyTitlePosition_post
} from 'server/modules/4168'
// 删除QA问题
export const faq_deleteQa_post_ = async function(params, cb) {
  const { success, retInfo } = await faq_deleteQa_post(params)
  if (success) {
    cb()
    message.success(retInfo)
    return true
  } else {
    message.error(retInfo)
    return false
  }
}

// 删除标题
export const faq_deleteTitle_post_ = async function(params, cb) {
  const { success, retInfo } = await faq_deleteTitle_post(params)
  if (success) {
    message.success(retInfo)
    cb()
    return true
  } else {
    message.error(retInfo)
    return false
  }
}

// 编辑QA问题顺序
export const faq_modifyPosition_post_ = async function(params, cb) {
  const { success, retInfo } = await faq_modifyPosition_post(params)
  if (success) {
    cb()
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询标题下QA问题列表
export const faq_queryQa_post_ = async function(params, state) {
  const { success, data, retInfo } = await faq_queryQa_post(params)
  if (success) {
    state.dataSource = data
  } else {
    message.error(retInfo)
  }
}

// 查询标题列表
export const faq_queryTitle_post_ = async function(params) {
  const { searchParams } = params
  const { success, data, retInfo } = await faq_queryTitle_post({
    ...searchParams
  })
  if (success) {
    params.dataSource = data
  } else {
    message.error(retInfo)
  }
}

// 新增/编辑QA问题
export const faq_upsertQa_post_ = async function(params, cb) {
  const { success, retInfo } = await faq_upsertQa_post(params)
  if (success) {
    message.success(retInfo)
    cb()
    return true
  } else {
    message.error(retInfo)
    return false
  }
}

// 新增/编辑标题
export const faq_upsertTitle_post_ = async function(params, cb) {
  const { success, retInfo } = await faq_upsertTitle_post({
    ...params,
    status: params.status ? 1 : 0
  })
  if (success) {
    cb()
    return true
  } else {
    message.error(retInfo)
    return false
  }
}

// 修改标题顺序
export const faq_modifyTitlePosition_post_ = async function(params, cb) {
  const { success, retInfo } = await faq_modifyTitlePosition_post(params)
  if (success) {
    cb()
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
